import { Divider, Skeleton } from '@mui/material';
import { API } from 'aws-amplify';
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Box, Spacer, Popover } from '@eatclubapp/ec-component-library';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useHistory } from 'react-router-dom';
import { setLogoutAction } from '../../../../actions/loginAction';
import { COLORS } from '../../../../EatClubTheme';
import { restaurantNameById } from '../../../../graphql/queries';
// import BusinessReviewModal from '../../../../screens/businessReview/BusinessReviewModal/BusinessReviewModal';
import CreditPopover from './CreditPopover';
import MarketBusinessModal from './MarketBusinessModal';
import ApplyCreditModal from './ApplyCreditModal';
import EnquirySentModal from './EnquirySentModal';
import CreditAppliedModal from './CreditAppliedModal';
import PrimaryChip from '../../../Chips/PrimaryChip';
import { devLog } from '../../../../utils';
import { trackDetailedEvent } from '../../../../utils/analytics';
import { loadFromSessionStorage, saveToSessionStorage } from '../../../../utils/apiHelpers';
import { isEmpty } from '../../../../utils/baseHelpers';
import { FEATURE_SCOPES, hasAccess } from '../../../../utils/permissions';
import useStyles from './RestaurantSwitcherStyles';
import ECPlateSVG from '../../../../assets/eatclub_plate.svg';
import RestaurantFinder from './RestaurantFinder/RestaurantFinder';
import { fetchAffiliatedRestaurantsAction } from '../../../../actions/restaurantAction';
import { fetchNetBalanceByRestIdAction } from '../../../../actions/settlementsAction';
import { formatCurrency, getAppVersion } from '../../../../utils/helpers';
import {
  affiliatedRestaurantsPropTypes,
  restaurantActivePropTypes,
} from '../../../../data/models/Restaurant';
import { userPropTypes } from '../../../../data/models/User';
import { Heading } from '../../../Heading';
import { Text } from '../../../Text';
import { getAppConfig } from '../../../../constants/appConfig';
import Mixpanel from '../../../../lib/mixpanel';

const RestaurantSwitcher = ({
  restaurantActive,
  setLogout,
  user,
  fetchAffiliatedRestaurants,
  affiliatedRestaurants,
  restaurantFetching,
  hideDrawer,
  creditRebate,
  netBalance,
  fetchNetBalance,
}) => {
  const history = useHistory();
  const classes = useStyles();
  const restaurant = restaurantActive?.restaurant;
  const isStaff = user.userInfo?.userType === 'staff';
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);

  const [finderAnchorEl, setFinderAnchorEl] = useState(null);
  const openFinder = Boolean(finderAnchorEl);

  const [venuesAnchorEl, setVenuesAnchorEl] = useState(null);
  const openVenues = Boolean(venuesAnchorEl);
  // const [showBusinessReview, setShowBusinessReview] = useState(false);
  const [mainRestaurant, setMainRestaurant] = useState(null);
  const [chipAnchorEl, setChipAnchorEl] = useState(null);
  const openChipMenu = Boolean(chipAnchorEl);
  const [showMarketBusinessModal, setShowMarketBusinessModal] = useState(false);
  const [showApplyCreditModal, setShowApplyCreditModal] = useState(false);
  const [showEnquirySentModal, setShowEnquirySentModal] = useState(false);
  const [showCreditAppliedModal, setShowCreditAppliedModal] = useState(false);
  const [creditAppliedAmount, setCreditAppliedAmount] = useState('');

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleOpenChipMenu = (event) => {
    event.stopPropagation(); // Prevent triggering the main menu
    setChipAnchorEl(event.currentTarget);
  };

  const handleCloseChipMenu = () => {
    setChipAnchorEl(null);
  };

  const handleOpenCreditHistory = () => {
    handleCloseChipMenu();
    hideDrawer();
    history.push('/settlements');
  };

  const handleOpenMarketBusiness = () => {
    handleCloseChipMenu();
    setShowMarketBusinessModal(true);
  };

  const handleCloseMarketBusinessModal = () => {
    setShowMarketBusinessModal(false);
  };

  const handleOpenApplyCredit = () => {
    handleCloseChipMenu();
    setShowApplyCreditModal(true);
  };

  const handleCloseApplyCreditModal = () => {
    setShowApplyCreditModal(false);
  };

  const sessionSelectedRestaurantId =
    user?.userInfo?.objectId &&
    loadFromSessionStorage(`selectedRestaurant:${user.userInfo.objectId}`);

  const affiliateAnchorRestId =
    restaurant?.objectId ||
    sessionSelectedRestaurantId ||
    user?.userInfo?.restaurants?.[0]?.objectId;

  useEffect(() => {
    if (affiliateAnchorRestId) {
      fetchAffiliatedRestaurants(affiliateAnchorRestId);
    }
  }, [fetchAffiliatedRestaurants, affiliateAnchorRestId]);

  useEffect(() => {
    if (restaurantActive?.restaurant?.objectId) {
      fetchNetBalance();
    }
  }, [fetchNetBalance, restaurantActive?.restaurant?.objectId]);

  // Fetch the "userById" venue since it doesn't come back in affiliated venues
  // TODO move this higher up in the app state
  useEffect(() => {
    (async () => {
      if (user?.userInfo?.restaurants?.[0]?.objectId) {
        try {
          const response = await API.graphql(
            {
              query: restaurantNameById,
              variables: {
                restId: user?.userInfo?.restaurants?.[0]?.objectId,
              },
              authMode: 'AMAZON_COGNITO_USER_POOLS',
            },
            {
              // 'user-id': userId,
              // 'user-type': userType,
              // 'rest-id': restId,
              'app-version': getAppVersion(),
              'ec-country': getAppConfig().ecCountryCode,
            },
          ).catch((error) => {
            throw new Error(error);
          });

          devLog('success', 'mainRestaurant', response.data.restaurantById);

          setMainRestaurant(response.data.restaurantById);
        } catch (error) {
          devLog('error', 'mainRestaurant', error);
        }
      }
    })();
  }, [user?.userInfo?.restaurants?.[0]?.objectId]);

  const normalizeVenueId = (id) => String(id || '').toUpperCase();

  const mergePartnerLinkedVenues = () => {
    const byId = new Map();
    const add = (entry) => {
      if (!entry?.objectId) return;
      const key = normalizeVenueId(entry.objectId);
      const prev = byId.get(key);
      byId.set(key, {
        objectId: prev?.objectId || entry.objectId,
        name: entry.name || prev?.name || '',
      });
    };
    (user?.userInfo?.restaurants || []).forEach(add);
    [mainRestaurant, ...(affiliatedRestaurants?.data || [])].forEach(add);
    return Array.from(byId.values());
  };

  const linkedRestaurants = mergePartnerLinkedVenues().filter(
    (entry) => normalizeVenueId(entry.objectId) !== normalizeVenueId(restaurant?.objectId),
  );

  const changeVenue = (venue) => {
    handleCloseMenu();

    Mixpanel.reset();

    saveToSessionStorage(`selectedRestaurant:${user?.userInfo?.objectId}`, venue.objectId);
    localStorage.setItem(`lastUsedRestaurant:${user?.userInfo?.objectId}`, venue.objectId);

    // Reload so all data gets fetched again
    window.location.reload();
  };

  // Show switcher label ASAP; only treat as "loading" if we still have no displayable name.
  // This avoids waiting on broader restaurant lists/affiliates before rendering the top label.
  const fallbackRestaurantName =
    restaurant?.name ||
    user?.userInfo?.restaurants?.[0]?.name ||
    user?.userInfo?.restaurants?.[0]?.title;
  // TODO fix a bug where staff without restaurant selected stays with restaurantFetching: true
  const isLoading =
    !fallbackRestaurantName && (restaurantActive?.fetching || (restaurantFetching && !isStaff));

  // Credit values from API
  const rebateData = creditRebate?.data;
  const availableCredit = rebateData?.availableCredit ?? 0;
  const accruedCredit = rebateData?.totalCredit ?? 0;
  const rebateCreditEnabled = rebateData?.rebateCreditEnabled ?? false;
  const pendingPayoutRequests = rebateData?.pendingPayoutRequests ?? [];
  const isCreditDisabled = availableCredit === 0;
  const displayCredit = isCreditDisabled ? accruedCredit : availableCredit;

  // Check if net balance is -100 or less (outstanding balance)
  const hasOutstandingBalance =
    netBalance?.data?.netBalance !== undefined &&
    netBalance?.data?.netBalance !== null &&
    netBalance?.data?.netBalance <= -100;

  // Only shows once credit data loaded successfully
  const hasCreditData =
    !creditRebate?.pending &&
    creditRebate?.success &&
    rebateData !== null &&
    rebateData !== undefined;
  // Hide chip if there's an outstanding balance (netBalance <= -100) or pending payout requests
  const hasPendingSettlementRequests = pendingPayoutRequests.some(
    (request) => request.payoutType === 'settlement',
  );
  const hasCreditToShow =
    hasCreditData && rebateCreditEnabled && accruedCredit !== 0 && !hasOutstandingBalance; // Only show chip if rebateCreditEnabled is true, totalCredit is not 0, no outstanding balance, and no pending settlement requests
  const isCreditDataLoaded =
    !creditRebate?.pending && (creditRebate?.success || creditRebate?.error);

  return (
    <Box style={{ position: 'relative' }}>
      <Box
        className={`${classes.restaurantSwitcherContainer} ${openChipMenu ? classes.restaurantSwitcherContainerActive : ''}`}
        onClick={(e) => handleOpenMenu(e)}
      >
        <Box className={classes.logoContainer}>
          <ECPlateSVG height={24} width={24} />
        </Box>

        {/* Show name and chip only when both restaurant and credit data are loaded to prevent layout shift */}

        <Box style={{ overflow: 'hidden' }}>
          <span className={`${classes.textOverflow}`}>
            {fallbackRestaurantName ||
              (isLoading && <Skeleton width={100} />) ||
              (isStaff && <Box style={{ color: COLORS.ERROR_RED }}>No restaurant</Box>)}
          </span>
        </Box>

        {/* Credit chip */}
        {isCreditDataLoaded && hasCreditToShow && (
          <PrimaryChip
            onClick={handleOpenChipMenu}
            className={`${classes.chip} ${isCreditDisabled ? classes.chipDisabled : ''}`}
          >
            {formatCurrency(displayCredit, true, '-', false, true)}
          </PrimaryChip>
        )}
      </Box>

      <Popover
        isOpen={openMenu}
        onClose={handleCloseMenu}
        anchorEl={anchorEl}
        style={{
          backgroundColor: '#00000070',
        }}
        innerStyle={{
          padding: 0,
          backgroundColor: 'transparent',
          boxShadow: 'none',
          pointerEvents: 'none',
          marginTop: '12px',
          borderRadius: 'none',
          width: '100%',
          maxWidth: '400px',
        }}
      >
        <>
          <Box className={classes.accountMenuContent}>
            {!isEmpty(restaurant) && (
              <>
                <Spacer gap='m'>
                  <Box className={classes.logoContainer}>
                    <ECPlateSVG height={34} width={34} />
                  </Box>

                  <Spacer direction='vertical' style={{ gap: '4px' }}>
                    <>
                      <Heading size='5'>{restaurant.name}</Heading>
                      <Text size='sm'>{restaurant.address1}</Text>
                    </>
                  </Spacer>
                </Spacer>

                <Divider className={classes.divider} style={{ marginTop: '12px' }} />
              </>
            )}

            <Box className={classes.navigationLinks} style={{ marginTop: '8px' }}>
              {/* Is a partner and has multiple affiliated venues */}
              {!isStaff && linkedRestaurants.length > 0 && (
                <Box
                  onClick={(e) => setVenuesAnchorEl(e.currentTarget || e.target)}
                  className={classes.navigationLink}
                >
                  Change venue
                </Box>
              )}

              {/* Is staff */}
              {isStaff && (
                <>
                  <Box
                    onClick={(e) => setFinderAnchorEl(e.currentTarget)}
                    className={classes.navigationLink}
                    style={{ backgroundColor: openFinder && 'rgba(49, 49, 49, 0.06)' }}
                  >
                    Change venue
                  </Box>

                  <Box
                    onClick={() => {
                      window.open(
                        `${import.meta.env.VITE_HUB_RESTAURANT_URL}/${
                          restaurantActive.restaurant.objectId
                        }`,
                        '_blank',
                      );
                    }}
                    className={classes.navigationLink}
                  >
                    Open in Hub
                  </Box>
                </>
              )}

              {hasAccess(user, FEATURE_SCOPES.PROFILE) && (
                <Box
                  className={classes.navigationLink}
                  onClick={() => {
                    hideDrawer();
                    handleCloseMenu();
                    history.push('/profile');
                  }}
                >
                  Profile
                </Box>
              )}

              {hasAccess(user, FEATURE_SCOPES.OFFERS) && (
                <Box
                  className={classes.navigationLink}
                  onClick={() => {
                    hideDrawer();
                    handleCloseMenu();
                    trackDetailedEvent('Clicked onboarding tour');
                    history.push('/tour');
                  }}
                >
                  Onboarding tour
                </Box>
              )}

              {/* {hasAccess(user, FEATURE_SCOPES.INSIGHTS) && (
                <Box
                  className={classes.navigationLink}
                  style={{
                    display: 'inline-flex',
                    gap: '12px',
                    whiteSpace: 'nowrap',
                  }}
                  onClick={() => {
                    trackDetailedEvent('Nav link clicked - QBR');
                    setShowBusinessReview(true);
                  }}
                >
                  Quarterly business review <Box className={classes.newLabel}>New</Box>
                </Box>
              )} */}

              <Box className={classes.navigationLink} onClick={setLogout}>
                Log out
              </Box>
            </Box>
          </Box>

          {!isStaff && (
            <Popover
              isOpen={!!openVenues}
              onClose={() => setVenuesAnchorEl(null)}
              anchorEl={venuesAnchorEl}
              innerProps={{
                disableAutoFocus: true,
                disableEnforceFocus: true,
                disableRestoreFocus: true,
                keepMounted: true,
              }}
              innerStyle={{
                borderRadius: '10px',
                fontSize: '18px',
                marginTop: '10px',
                padding: '8px',
                width: '380px',
              }}
            >
              <Box className={classes.navigationLinks}>
                <>
                  {linkedRestaurants.map((affiliatedRestaurant) => (
                    <Box
                      key={affiliatedRestaurant.objectId}
                      className={classes.navigationLink}
                      onClick={() => {
                        changeVenue(affiliatedRestaurant);
                        setVenuesAnchorEl(null);
                      }}
                    >
                      {affiliatedRestaurant.name || 'Venue'}
                    </Box>
                  ))}
                </>
              </Box>
            </Popover>
          )}

          {isStaff && (
            <RestaurantFinder
              isOpen={openFinder}
              onClose={() => setFinderAnchorEl(null)}
              onSelect={(venue) => {
                changeVenue(venue);
                setFinderAnchorEl(null);
              }}
              anchorEl={finderAnchorEl}
            />
          )}

          {/* <BusinessReviewModal
            isOpen={showBusinessReview}
            onClose={() => setShowBusinessReview(false)}
            onConfirm={() => {
              setShowBusinessReview(false);
              handleCloseMenu();
              hideDrawer();
            }}
          /> */}
        </>
      </Popover>

      <CreditPopover
        isOpen={openChipMenu}
        onClose={handleCloseChipMenu}
        anchorEl={chipAnchorEl}
        onMarketBusinessClick={handleOpenMarketBusiness}
        onApplyCreditClick={handleOpenApplyCredit}
        onCreditHistoryClick={handleOpenCreditHistory}
        availableCredit={String(availableCredit)}
        accruedCredit={String(accruedCredit)}
        pendingPayoutRequests={pendingPayoutRequests}
        netBalance={netBalance?.data?.netBalance}
      />

      <MarketBusinessModal
        isOpen={showMarketBusinessModal}
        onClose={handleCloseMarketBusinessModal}
        availableCredit={String(availableCredit)}
        onEnquirySent={() => setShowEnquirySentModal(true)}
      />

      <ApplyCreditModal
        isOpen={showApplyCreditModal}
        onClose={handleCloseApplyCreditModal}
        availableCredit={String(availableCredit)}
        onCreditApplied={(amount) => {
          setCreditAppliedAmount(amount);
          setShowCreditAppliedModal(true);
        }}
      />

      <EnquirySentModal
        isOpen={showEnquirySentModal}
        onClose={() => setShowEnquirySentModal(false)}
      />

      <CreditAppliedModal
        isOpen={showCreditAppliedModal}
        onClose={() => setShowCreditAppliedModal(false)}
        creditAmount={creditAppliedAmount}
      />
    </Box>
  );
};

RestaurantSwitcher.propTypes = {
  restaurantActive: restaurantActivePropTypes.isRequired,
  user: userPropTypes.isRequired,
  setLogout: PropTypes.func.isRequired,
  fetchAffiliatedRestaurants: PropTypes.func.isRequired,
  affiliatedRestaurants: affiliatedRestaurantsPropTypes.isRequired,
  restaurantFetching: PropTypes.bool.isRequired,
  hideDrawer: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  restaurantActive: state.restaurantActive,
  user: state.user,
  affiliatedRestaurants: state.affiliatedRestaurants,
  restaurantFetching: state.restaurants.fetching,
  creditRebate: state.creditRebate,
  netBalance: state.netBalance,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      setLogout: setLogoutAction,
      fetchAffiliatedRestaurants: fetchAffiliatedRestaurantsAction,
      fetchNetBalance: fetchNetBalanceByRestIdAction,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(RestaurantSwitcher);
